<template>
 <div>
    <relationship-update
      :ams_type="ams_type"
      :response_data="response_data"
      :response_included="response_included"
      @updateRelationship="resetRelationship"
      @descriptionUpdate="setDescription"
    ></relationship-update>
   <br>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card bg-variant="light">
          <div id="header-id-product-model-id">
        <div v-if="showSelection">
          <product-model-select @selectedItems="setId" />
        </div>
          </div>
          <b-form-group 
            label-cols-lg="3"
            label="Product Listing"
            label-size="lg"
            label-class="font-weight-bold pt-0"
            class="mb-0"
          >
            <b-form-group
              label="Edition:"
              label-for="nested-edition"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input id="nested-edition" type="number"
                v-model="attr_copy.edition"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Price:"
              label-for="nested-price-cents"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-input-group size="sm" prepend="$">
                <b-form-input-currency id="nested-price-cents"
                  v-model="attr_copy['price-cents']"
                ></b-form-input-currency>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Description:"
              label-for="nested-description"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input id="nested-description"
                v-model="attr_copy.description"
              ></b-form-input>
            </b-form-group>
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="1">
        <data-operations
          :modified="modified"
          :can_update="canUpdate"
          :can_delete="canDelete"
          :can_help="canHelp"
          @update="doUpdate"
          @undo="doUndo"
          @delete="doDelete"
          @cancel="doCancel"
          @help="doHelp"
        ></data-operations>
      </b-col>
    </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import {amsMofifiedAttrs, deepEqual, amsTitle} from '@/utils'
import DataOperations from './DataOperations.vue'
import BFormInputCurrency from './BFormInputCurrency.vue'
import ProductModelSelect from './ProductModelSelect.vue'
import RelationshipUpdate from './RelationshipUpdate.vue'

export default {
  components: { 
    BFormInputCurrency,
    DataOperations,
    ProductModelSelect,
    RelationshipUpdate
  },
  props: {
    id: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: 'product-listings',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      reassigned: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      response_data: undefined,
      response_included: undefined
    }
  },
  computed: {
    showSelection() {
      return !(this.attr_copy['product-model-id']?.length)
    },
    canUpdate() {
      return (this.attr_copy['product-model-id']?.length > 0 && (this.attr_copy['edition']?.length > 0 || this.attr_copy['edition'] > 0))
    },
    canDelete() {
      return true
    },
    canHelp() {
      return true
    }
  },
  methods: {
    jumpToId(id) {
      const element = document.getElementById(id)
      if(element) {
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
      } else {
        window.console.log( "could not find document element by id: " + id)
      }
    },
    resetRelationship(item) {
      window.console.log('resetRelationship for ' + item)
      this.attr_copy[item] = null
      this.jumpToId("header-id-" + item)
    },
    setDescription(description) {
      this.description = description
    },
    setId(items) {
      this.attr_copy['product-model-id'] = items[0].id
      this.description = items[0].attributes['name']
    },
    doRelocation() {
      this.attr_copy['product-model-id'] = null
    },
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
      http_v1.delete (
        this.apiResourcePath()
      ).then(response => {
        if( response.status == 204) {
          this.$router.go(-1)
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_') + '/' + this.id
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.patch (
         this.apiResourcePath(), {
          ...attr_params
        }
      ).then(() => {
        this.$router.go(-1)
      }).catch(error => {
        window.console.log(error)
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.attr_copy = Object.assign( {}, response.data.data.attributes)
        this.attr_orig = Object.assign( {}, response.data.data.attributes)
        this.response_data = response.data.data
        this.response_included = response.data.included
        this.$emit('gotAttrs', this.attr_copy, amsTitle(response.data.data, 'edition', "Update"))
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>